import type { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns'
import { unscopeSearchDocumentIdForHydration } from 'features/knowledgeDocumentViewer/utils/pipelineConfigScopedIds'

export function buildCitationDocumentLookup(
  documentResults: DocumentTableRow[]
): Map<string, DocumentTableRow> {
  const lookup = new Map<string, DocumentTableRow>()
  for (const row of documentResults) {
    lookup.set(row.id, row)
    if (row.bqDocumentId) {
      lookup.set(row.bqDocumentId, row)
    }
  }
  return lookup
}

export function resolveCitationDocument({
  citationDocumentId,
  documentResults,
  pipelineConfigId,
  lookup,
}: {
  citationDocumentId: string
  documentResults: DocumentTableRow[]
  pipelineConfigId?: string
  lookup?: Map<string, DocumentTableRow>
}): DocumentTableRow | undefined {
  const byId = lookup ?? buildCitationDocumentLookup(documentResults)
  const direct = byId.get(citationDocumentId)
  if (direct) return direct
  const unscoped = unscopeSearchDocumentIdForHydration(
    citationDocumentId,
    pipelineConfigId
  )
  if (unscoped !== citationDocumentId) {
    return byId.get(unscoped)
  }
  return undefined
}
